import { capture } from '@/lib/analytics';
import type { OrganizationPlanId, OrganizationType } from '@/lib/db/schema';

export type EnterpriseBookingCtaSource =
  | 'admin_dashboard'
  | 'admin_billing'
  | 'admin_invitations'
  | 'admin_members'
  | 'sidebar_user_nav'
  | 'signup_onboarding';

export interface EnterpriseBookingCtaEventProperties {
  source: EnterpriseBookingCtaSource;
  organizationType: OrganizationType;
  organizationPlanId?: OrganizationPlanId;
  userRole: string;
  destinationKind: 'booking_url' | 'mailto_fallback';
}

export interface EnterpriseBookingCtaTrackingInput {
  source: EnterpriseBookingCtaSource;
  organizationType: OrganizationType;
  organizationPlanId?: OrganizationPlanId;
  userRole: string;
  contactUrl: string;
}

export function getEnterpriseBookingDestinationKind(
  contactUrl: string,
): EnterpriseBookingCtaEventProperties['destinationKind'] {
  return contactUrl.startsWith('mailto:') ? 'mailto_fallback' : 'booking_url';
}

export function captureEnterpriseBookingCtaClicked(
  input: EnterpriseBookingCtaTrackingInput,
): void {
  capture('enterprise_booking_cta_clicked', {
    source: input.source,
    organizationType: input.organizationType,
    organizationPlanId: input.organizationPlanId,
    userRole: input.userRole,
    destinationKind: getEnterpriseBookingDestinationKind(input.contactUrl),
  });
}
